'use strict';

const trueOptions = ['y', 'yes', 'true'];
const falseOptions = ['n', 'no', 'false'];

module.exports = {
  trueOptions,
  falseOptions,
};
